/**
 * Frieze — exact global constants (§7 of the source spec).
 * These are the tuning of the piece; do not round or "improve" them.
 */
export const FZ = {
    /* settled geometry */
    ROT_STEP: 24,
    STRIDE_FRAC: 0.19,
    STRIDE_FRAC_MOBILE: 0.64,
    ZSTEP: 22,
    EDGE_GROW: 0.1,
    PERSPECTIVE: 1300,
    CYL_LIFT: 0,

    /* scroll physics — position is in CARD units */
    FRICTION: 0.93,
    SNAP_VEL: 0.14,
    SNAP_STRENGTH: 0.12,
    WHEEL_FACTOR: 0.0007,
    MAX_WHEEL_V: 1.3,
    INPUT_SNAP_DELAY: 150,
    DRAG_FACTOR: 0.0052,
    CARD_V_PEAK: 0.5,
    DRAG_AXIS_LOCK: 8,
    CLICK_SLOP: 6,
    TARGET_EASE: 0.14,

    /* loupe */
    LENS_R: 37.5,

    /* intro timeline (seconds) */
    BLACK_HOLD: 0.35,
    APPEAR_DUR: 0.55,
    APPEAR_STAGGER: 0.17,
    LINE_AT: 2.15,
    LINE_DUR: 1.1,
    ZOOM_AT: 3.45,
    ZOOM_DUR: 2.0,
    LINE_SCALE: 0.42,
    CHROME_AT: 5.6,

    /* open / close */
    OPEN_DUR: 1.9,
    CLOSE_DUR: 1.35
} as const

/** 17 chromatic-aberration levels + 1 sharp level (§12). */
export const CA_LEVEL_COUNT = 17

export const CA_LEVELS = Array.from({ length: CA_LEVEL_COUNT }, (_, index) => {
    const level = index + 1
    const t = Math.pow(level / CA_LEVEL_COUNT, 1.15)

    return {
        level,
        blur: Number((t * 16).toFixed(4)),
        dx: Number((t * 13).toFixed(4))
    }
})
